import { Link } from 'react-router-dom';

const ENTRIES = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影频道',
    desc: '动作 · 科幻 · 悬疑',
    color: 'bg-primary-500',
  },
  {
    to: '/category/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧频道',
    desc: '都市 · 古装 · 悬疑',
    color: 'bg-secondary-500',
  },
  {
    to: '/category/variety',
    icon: 'ri-mic-line',
    title: '综艺频道',
    desc: '脱口秀 · 真人秀',
    color: 'bg-accent-500',
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={`w-14 h-14 md:w-16 md:h-16 rounded-lg ${entry.color} text-background-50 flex items-center justify-center shrink-0`}>
              <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {entry.title}
              </span>
              <span className="block mt-1 text-xs md:text-sm text-foreground-600 truncate">{entry.desc}</span>
            </span>
            <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}